import React from 'react';

// Botón reutilizable con variantes para el dashboard y vistas
// Props:
// - variant: 'dark' | 'accent' | 'outline'
// - activo: resalta con ring
// - fullWidth: ocupa 100% del ancho
// - className: clases adicionales
// - ...props: onClick, disabled, etc.
const BotonAcceso = ({
    variant = 'dark',
    activo = false,
    fullWidth = false,
    className = '',
    children,
    ...props
}) => {
    const base = 'inline-flex items-center justify-center font-semibold rounded-xl transition-colors duration-150 focus:outline-none focus:ring-2';
    const ring = activo ? ' ring-2 ring-emerald-500' : '';
    const width = fullWidth ? ' w-full' : '';

    let variantClasses = '';
    switch (variant) {
        case 'accent':
            // Botón naranja gradiente (como el de \"Editar pedido semanal\")
            variantClasses = ' text-white bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 shadow-md hover:shadow-lg';
            break;
        case 'outline':
            variantClasses = ' text-zinc-200 border border-zinc-700 hover:bg-zinc-800';
            break;
        case 'dark':
        default:
            variantClasses = ' bg-zinc-900 text-zinc-200 hover:bg-zinc-700 focus:ring-zinc-700';
            break;
    }

    const size = ' px-4 py-2';

    return (
        <button className={`${base}${ring}${width}${size} ${variantClasses} ${className}`} {...props}>
            {children}
        </button>
    );
};

export default BotonAcceso;
